import Vue from "vue";
import axios from "axios";
import { cacheAdapterEnhancer } from "axios-extensions";
import { clientEnvironmentCode } from "@/environment/environment";

import store from "@/app/app-state";

class RestClient {
  constructor(baseUrl, anonymous = false) {
    this.RestClientLoadingCount = 0;

    this.handleError = true;
    let notimeout = true;
    let timeout = notimeout ? 0 : 2500;

    this.Instance = axios.create({
      timeout: timeout,
      baseURL: baseUrl,
      crossDomain: true,
      headers: {
        "Cache-Control": "no-cache"
      },
      // disable the default cache
      adapter: cacheAdapterEnhancer(axios.defaults.adapter, { enabledByDefault: false })
    });

    var self = this;

    this.Instance.interceptors.request.use(
      function(config) {
        //on donne le token courant lors de l'appel
        if (!anonymous) {
          let authToken = store.getters["userContext/getToken"];
          //config.headers.Authorization = "Bearer " + authToken;

          config.headers = {
            Authorization: "Bearer " + authToken,
            "X-Tesfri-EnvironmentCode": clientEnvironmentCode,
            "X-Tesfri-CompanyCode": store.state.userContext.currentCompany,
            "X-Tesfri-WarehouseCode": store.state.userContext.currentWarehouse
          };
        }
        self.RestClientLoadingCount += 1;
        window.postMessage({ type: "loading", value: self.RestClientLoadingCount });

        return config;
      },
      function(error) {
        // Pull config, status and data from the error
        const { config } = error;

        if (self.handleError) {
          //Notification.notifyError('Remote Connection', `${config.url}: ${error.message}`)
          Vue.$log.error("Remote Connection " + `${config.url}: ${error.message}`);
          return Promise.reject(error);
        }
        return config;
      }
    );

    this.Instance.interceptors.response.use(
      function(response) {
        self.RestClientLoadingCount -= 1;
        window.postMessage({ type: "loading", value: self.RestClientLoadingCount });
        return response;
      },
      function(error) {
        self.RestClientLoadingCount -= 1;
        window.postMessage({ type: "loading", value: self.RestClientLoadingCount });
        // Pull config, status and data from the error
        const { config, response } = error;
        //Si on est en 409, on ne veux pas de message, on le gère par une modale Oui/Non
        if (self.handleError === true && response.status !== 409) {
          //Notification.notifyError('Remote Connection', `${config.url}: ${error.message}`)
          Vue.$log.error("Remote Connection " + `${config.url}: ${error.message}`);
          return Promise.reject(error).then(
            function() {},
            function() {
              return response;
            }
          );
        }
        return response;
      }
    );
  }
}

export default RestClient;
